// extracted by mini-css-extract-plugin
module.exports = {"ko-KR":"chat_ko-KR__lWQ5z","impressionTrackingContainer":"chat_impressionTrackingContainer__ewdV8","chatPageContainer":"chat_chatPageContainer__o3WSN","spin":"chat_spin__P16lz"};